// Anonymous landing-page funnel tracking — feeds the in-app "Landing funnel"
// card so we can see where public-site visitors drop before signing up.
const BACKEND = process.env.REACT_APP_BACKEND_URL;

function visitorId() {
  try {
    let vid = localStorage.getItem("sp_vid");
    if (!vid) {
      vid = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem("sp_vid", vid);
    }
    return vid;
  } catch {
    return "";
  }
}

export function trackMkt(action, label = "") {
  try {
    const utm = new URLSearchParams(window.location.search).get("utm_source") || "";
    fetch(`${BACKEND}/api/track/event`, {
      method: "POST",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        action,
        label: String(label),
        path: window.location.pathname,
        utm_source: utm,
        visitor_id: visitorId(),
      }),
    }).catch(() => {});
  } catch {
    /* never let tracking break the page */
  }
}
